import { useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    Select
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function TransferSelect({
    closeIt, handleSubmit, usersList
}){
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const [p, setP] = useState({});
    //--------------------------------------------------------------------------------------------
    return (
        <Modal
            closeIt = {closeIt}
            title = "Forward Approval"
            width = {300}
            handleFormSubmit = {handleSubmit}
            actionKey = "Forward"
        >
            <Select
                className = "m-3"
                options = {usersList.filter(u => u.purchases === "approver" && u.email !== user.email)} 
                onChange = {e => {setP(e)}}
            />
            <input name = "forward" value = {JSON.stringify(p)} readOnly className = "nodisplay"/>
        </Modal>
    )
}